import React, { useEffect, useState } from "react";
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Select from "@mui/material/Select";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment/moment";
import { useAppMutation } from "../../../services";
import parentServices from "../../../services/parent-services";
import { PHONE_COUNTRIES, timings } from "../../../utils/constants/appActions";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import GoogleIcon from "@mui/icons-material/Google";
import BubbleChartIcon from "@mui/icons-material/BubbleChart";
import InfoIcon from "@mui/icons-material/Info";

const StepStudent = ({
  errMsg,
  setStep,
  isLoading,
  handleBack,
  childValues,
  handleChildChange,
  selectedChildIndex,
  StepIndicator,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const [pastDate, setPastDate] = useState(false);
  const [maxDate, setMaxDate] = useState();
  const [minDate, setMinDate] = useState();
  const [type] = useState("evaluation");
  const [sTimings, setSTimings] = useState([]);

  const {
    mutate: loadAvailableDates,
    isSuccess: isLDSuccess,
    isLoading: isLDLoading,
    isError: isLDError,
    data: ldResult,
  } = useAppMutation(parentServices.loadAvailableDates);

  const {
    mutate: loadAvailableTimes,
    isSuccess: isLTSuccess,
    isLoading: isLTLoading,
    isError: isLTError,
    data: ltResult,
  } = useAppMutation(parentServices.loadAvailableTimes);

  useEffect(() => {
    console.log("LD Result", isLTSuccess, ltResult, selectedChildIndex);

    if (isLTError) {
      setSTimings([]);
      return;
    }

    if (!ltResult) {
      setSTimings([]);
      return;
    }

    const start = childValues[selectedChildIndex]?.startDate;
    if (!(start instanceof Date) || isNaN(start.getTime())) {
      setSTimings([]);
      return;
    }

    console.log("ltResult---->>>", ltResult);
    const startDate = moment(start).format("YYYY-MM-DD");
    console.log("startStr---->>>", startDate);
    const now = new Date();
    const ls = [];

    for (const t of ltResult.timings) {
      let date = new Date(`${startDate}T${t}`);
      const userTimezoneOffset = date.getTimezoneOffset() * 60000;
      date = new Date(date.getTime() - userTimezoneOffset);

      if (date > new Date()) {
        const v = timings.find(
          (item) => item.value === moment(date).format("HH:mm"),
        );

        if (v) {
          ls.push(v);
        }
      }
    }

    console.log("ls---->>>", ls);

    setSTimings(ls);
  }, [isLTSuccess, isLTError]);

  React.useEffect(() => {
    if (!minDate) {
      const currentMin = new Date();
      const currentMax = new Date();
      currentMin.setDate(currentMin.getDate()+2);
      setMinDate(currentMin);
      currentMax.setDate(currentMax.getDate() + 30);
      setMaxDate(currentMax);
      loadAvailableDates({ type, startDate: currentMin, endDate: currentMax });
    }
  }, [minDate]);

  const getMaxDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  return (
    <>
      <Paper
        elevation={6}
        sx={{
          p: 4,
          borderRadius: 3,
          bgcolor: "#fff",
          color: "#000",
          maxWidth: 600,
          mx: "auto",
        }}
      >
        {!handleBack && (
          <Box sx={{ textAlign: "center", mb: 2 }}>
            <img src="/images/logos/logo.png" alt="Logo" width="100" />
          </Box>
        )}

        {!handleBack && (
          <Divider sx={{ my: 2 }}>
            <Typography
              variant="h3"
              sx={{
                mb: 1,
                fontFamily: "'Red Hat Display', sans-serif",
                color: "#002465",
              }}
              align="center"
              gutterBottom
            >
              {t("parent-signup.title.signupHeadingNewStudent")}
            </Typography>
          </Divider>
        )}

        {/*<Box sx={{ display: "flex", alignItems: "center", mb: 6 }}>
          {handleBack && (
            <IconButton onClick={handleBack} sx={{ p: 0, mr: 1 }}>
              <ArrowBackIcon />
            </IconButton>
          )}
          {handleBack && (
            <Typography
              sx={{ color: "#003366", fontWeight: "bold", fontSize: "1.15rem" }}
            >
              Votre enfant
            </Typography>
          )}
        </Box>*/}

        <Box
          sx={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mb: 6,
          }}
        >
          {handleBack && (
            <IconButton
              onClick={handleBack}
              sx={{
                position: "absolute",
                left: 0,
                top: "50%",
                transform: "translateY(-50%)",
                width: 40,
                height: 40,
                borderRadius: "50%", // 👈 makes it round
                border: "1px solid #002465", // 👈 outer circle border
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                "&:hover": {
                  bgcolor: "#f0f4f8", // light hover background
                },
              }}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          {handleBack && (
            <Typography
              variant="h3"
              sx={{
                fontFamily: "'Red Hat Display', sans-serif",
                color: "#002465",
              }}
              align="center"
              gutterBottom
            >
              {t("parent-signup.title.signupHeadingNewStudent")}
            </Typography>
          )}
        </Box>

        {childValues.map((child, index) => (
          <React.Fragment key={index}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  size="small"
                  margin="none"
                  sx={{
                    mb: { xs: 1, md: 2 },
                    "& .MuiInputBase-input": {
                      fontFamily: "'Lexend', sans-serif",
                    },
                    "& .MuiInputLabel-root": {
                      fontFamily: "'Lexend', sans-serif",
                    },
                  }}
                  required
                  label="Prénom de l'enfant"
                  value={childValues[index].firstName}
                  onChange={(e) =>
                    handleChildChange(index, "firstName", e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  size="small"
                  margin="none"
                  sx={{
                    mb: { xs: 1, md: 2 },
                    "& .MuiInputBase-input": {
                      fontFamily: "'Lexend', sans-serif",
                    },
                    "& .MuiInputLabel-root": {
                      fontFamily: "'Lexend', sans-serif",
                    },
                  }}
                  required
                  label="Nom de famille"
                  value={childValues[index].lastName}
                  onChange={(e) =>
                    handleChildChange(index, "lastName", e.target.value)
                  }
                />
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{ mt: 1, mb: 2 }}
            >
              <Grid item xs={12} md={6}>
                <TextField
                  id={`date-${index}`}
                  required
                  label={t("parent-children.title.dateBirth")}
                  type="date"
                  fullWidth
                  size="small"
                  inputProps={{
                    max: getMaxDate(),
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={childValues[index].dateOfBirth}
                  onChange={(e) =>
                    handleChildChange(index, "dateOfBirth", e.target.value)
                  }
                  sx={{
                    "& .MuiInputBase-input": {
                      fontFamily: "'Lexend', sans-serif",
                    },
                    "& .MuiInputLabel-root": {
                      fontFamily: "'Lexend', sans-serif",
                    },
                  }}
                />
              </Grid>

              {/* Gender Selection */}
              <Grid item xs={12} md={6}>
                <FormControl component="fieldset" sx={{ mt: { xs: 1, md: 0 } }}>
                  <RadioGroup
                    row
                    value={childValues[index].gender}
                    onChange={(e) =>
                      handleChildChange(index, "gender", e.target.value)
                    }
                    aria-label="gender"
                    name={`child-gender-group-${index}`}
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontFamily: "'Lexend', sans-serif",
                      },
                    }}
                  >
                    <FormControlLabel
                      value="male"
                      control={<Radio size="small" />}
                      label="Garçon"
                    />
                    <FormControlLabel
                      value="female"
                      control={<Radio size="small" />}
                      label="Fille"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </Grid>

            <Box sx={{ textAlign: "center", mb: 3, mt: 4 }}>
              <Typography
                sx={{
                  mt: 1,
                  color: "#003366", // dark blue
                  fontWeight: "bold",
                  fontSize: "1.15rem", // ~20px
                  fontFamily: "'Red Hat Display', sans-serif",
                }}
              >
                Réservation de son entretien de départ
              </Typography>

              <Typography
                sx={{
                  mt: 1,
                  mb: 2,
                  color: "#003368", // light blue
                  fontFamily: "'Lexend', sans-serif",
                }}
              >
                Cet échange de 25 minutes <br />
                nous permettra de lui créer son parcours sur mesure.
              </Typography>
            </Box>

            <Grid
              container
              spacing={2}
              alignItems="center"
              sx={{ mt: 1, mb: 2 }}
            >
              {/* Date Picker */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <Stack spacing={3}>
                      <DesktopDatePicker
                        open={open}
                        onOpen={() => setOpen(true)}
                        onClose={() => setOpen(false)}
                        shouldDisableDate={(day) => {
                          if (pastDate) {
                            return false;
                          }
                          const formatted = moment(day).format("YYYY-MM-DD");
                          const today = moment().format("YYYY-MM-DD");
                          if (formatted === today) {
                            return true;
                          }
                          if (
                            ldResult?.availableDates &&
                            ldResult.availableDates.includes(
                              moment(day).format("YYYY-MM-DD"),
                            )
                          ) {
                            return false;
                          }
                          return true;
                        }}
                        minDate={pastDate ? undefined : minDate}
                        maxDate={pastDate ? undefined : maxDate}
                        label={t("common.date")}
                        format="dd/MM/yyyy"
                        value={childValues[index]?.startDate ?? null}
                        onChange={(newDate) => {
                          // newDate is a Date or null
                          handleChildChange(
                            index,
                            "startDate",
                            newDate ?? null,
                          );

                          if (newDate) {
                            // If you need to load times immediately after picking a date:

                            const date = moment(newDate).format("YYYY-MM-DD");

                            loadAvailableTimes({ type, date });
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            InputLabelProps={{ shrink: true }}
                            sx={{
                              "& .MuiInputBase-input": {
                                fontFamily: "'Lexend', sans-serif",
                              },
                              "& .MuiInputLabel-root": {
                                fontFamily: "'Lexend', sans-serif",
                              },
                            }}
                          />
                        )}
                      />
                    </Stack>
                  </LocalizationProvider>
                </FormControl>
              </Grid>

              {/* Time Select */}
              <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                  <>
                    <InputLabel id="demo-simple-select-label">
                      {t("parent.title.time")}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={childValues[index]?.startTime ?? null}
                      label={t("common.time")}
                      onChange={(e) =>
                        handleChildChange(index, "startTime", e.target.value)
                      }
                      sx={{
                        "& .MuiSelect-select": {
                          fontFamily: "'Lexend', sans-serif",
                        },
                      }}
                    >
                      {sTimings.map((item, index) => (
                        <MenuItem key={index} value={item.value}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </>
                </FormControl>
              </Grid>
            </Grid>

            <Box
              sx={{
                width: "100%", // full width of the form container
                minHeight: 50,
                mb: 2,
                mt: 1,
              }}
            >
              {errMsg && (
                <Alert
                  severity="error"
                  sx={{
                    height: "100%",
                    fontSize: 13,
                    fontFamily: "'Lexend', sans-serif",
                  }}
                >
                  {errMsg}
                </Alert>
              )}
            </Box>

            <Button
              variant="outlined"
              fullWidth
              startIcon={<BubbleChartIcon />}
              sx={{
                mb: 2,
                borderRadius: 3,
                textTransform: "none",
                backgroundColor: "#1D6ADE",
                fontFamily: "'Lexend', sans-serif",
                color: "#fff",
                "&:hover": {
                  backgroundColor: "#265ca6", // darker red on hover
                },
              }}
              onClick={setStep}
              disabled={isLoading}
            >
              {isLoading
                ? "........."
                : !handleBack
                  ? t("parent-signup.title.continue")
                  : t("parent-signup.title.signupHeadingNewStudentBtn")}
            </Button>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mt: 3,
                mb: 1,
              }}
            >
              <InfoIcon sx={{ fontSize: 18, color: "gray", mr: 1 }} />
              <Typography
                sx={{
                  color: "#003368",
                  textAlign: "center",
                  fontFamily: "'Lexend', sans-serif",
                }}
              >
                Vous pourrez modifier l'horaire de l'entretien plus tard si
                besoin.
              </Typography>
            </Box>
          </React.Fragment>
        ))}
      </Paper>
    </>
  );
};

export default StepStudent;
